<template>
	<div
		class="g-block-video-row"
		:class="{
			'g-block-video-row--edit': editable,
			'is-active': editable && active,
			'g-block-video-row--h5': h5,
			'g-block-video-row--card': blockStyle.showCard,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-video-row__card"
			:style="cardStyle"
		>
			<div
				class="g-block-video-row__list"
				:style="{ gap: blockStyle.itemGap }"
			>
				<div
					v-for="item in items"
					:key="item.id"
					class="g-block-video-row__item"
				>
					<div
						class="g-block-video-row__thumb"
						:class="{ 'is-playable': isPlayable }"
						:style="thumbStyle"
						@click="onItemClick(item, $event)"
					>
						<img
							v-if="getCoverUrl(item)"
							:src="getCoverUrl(item)"
							alt=""
						/>
						<i v-else class="mbm-iconfont mbm-shipin"></i>
						<span class="g-block-video-row__play" aria-hidden="true">
							<span class="g-block-video-row__triangle"></span>
						</span>
					</div>
					<div class="g-block-video-row__info">
						<div
							class="g-block-video-row__title"
							:style="{ color: item.titleColor }"
						>
							{{ item.title }}
						</div>
						<div
							class="g-block-video-row__desc"
							:style="{ color: item.descColor }"
						>
							{{ item.description }}
						</div>
						<div
							class="g-block-video-row__meta"
							:style="{ color: item.durationColor }"
						>
							<svg class="g-block-video-row__clock" viewBox="0 0 24 24" fill="none" aria-hidden="true">
								<circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8" />
								<path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
							</svg>
							<span>{{ getDurationText(item) }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<video
			v-if="playingUrl"
			ref="playerEl"
			class="g-block-video-row__player"
			:src="playingUrl"
			controls
			playsinline
			@ended="onPlayEnded"
		></video>
		<i v-if="playingUrl" class="mbm-iconfont mbm-guanbi g-block-video-row__close" @click="stopPlay"></i>
	</div>
</template>

<script>
	import baseFunc from '../../../../config/base_func.js';
	import {
		getVideoRowBlockStyle,
		getVideoRowCoverUrl,
		getVideoRowVideoUrl,
		normalizeVideoRowData,
	} from '../../../utils/videoRow.js';

	export default {
		name: 'GVideoRowShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
			idKey: {
				type: String,
				default: '',
			},
		},
		emits: ['select'],
		data() {
			return {
				playingUrl: '',
				permissionRequests: {},
				currentPlayingItem: null,
			};
		},
		computed: {
			normalizedData() {
				return normalizeVideoRowData(this.data);
			},
			items() {
				return this.normalizedData.items;
			},
			blockStyle() {
				return getVideoRowBlockStyle(this.data, { h5: this.h5 });
			},
			thumbStyle() {
				return {
					width: this.blockStyle.thumbWidth,
					height: this.blockStyle.thumbHeight,
					borderRadius: this.blockStyle.coverBorderRadius,
				};
			},
			cardStyle() {
				if (!this.blockStyle.showCard) {
					return {};
				}
				return {
					borderRadius: this.blockStyle.cardBorderRadius,
					padding: this.blockStyle.cardPadding,
				};
			},
			isPlayable() {
				return this.editable || this.h5;
			},
		},
		beforeUnmount() {
			this.stopPlay();
		},
		methods: {
			getCoverUrl(item) {
				return getVideoRowCoverUrl(item);
			},
			getDurationText(item) {
				return item.video?.durationText || '00:00';
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onItemClick(item, e) {
				if (!this.isPlayable) return;
				e?.stopPropagation?.();
				const url = getVideoRowVideoUrl(item);
				if (!url) return;
				this.currentPlayingItem = item;
				const itemId = item.video?.id;
				if (this.h5 && itemId && !this.permissionRequests[itemId]) {
					this.permissionRequests[itemId] = true;
					this.requestPlayPermission(item, url).then(() => {
						this.$nextTick(() => {
							this.$refs.playerEl?.play?.();
						});
					}).catch((err) => {
						this.permissionRequests[itemId] = false;
						this.$refs.playerEl?.pause?.();
						this.$message.error(err.data?.message || '请求失败');
					});
				} else {
					this.playingUrl = url;
					this.$nextTick(() => {
						this.$refs.playerEl?.play?.();
					});
				}
			},
			//访问路径中取指定的值
			getQueryStringByChannel(name) {
				const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
				if (!window.location.href.split('?')[1]) {
					return null
				}
				const re = window.location.href.split('?')[1].match(reg)
				if (re != null) return unescape(re[2])
				return null
			},
			requestPlayPermission(item, fallbackUrl) {
				return this.$apiRequest.post('/api/getMediaPlayPermissions', {
					attach_id: item.video.id,
					id_key: this.idKey,
					unique: '',
					app_type:1,
					p_key: this.getQueryStringByChannel('p_key')==null?'':this.getQueryStringByChannel('p_key'),
				}).then(res => {
					if (res.data?.play_url) {
						this.playingUrl = baseFunc.getQiniusign(res.data.play_url);
					} else {
						this.playingUrl = fallbackUrl;
					}
				});
			},
			onPlayEnded() {
				this.stopPlay();
			},
			stopPlay() {
				const el = this.$refs.playerEl;
				if (el) {
					el.pause();
				}
				this.playingUrl = '';
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-video-row {
		width: 100%;
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-video-row__card {
		box-sizing: border-box;
		width: 100%;

		.g-block-video-row--card & {
			background: #fff;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		}
	}

	.g-block-video-row__list {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.g-block-video-row__item {
		display: flex;
		align-items: stretch;
		gap: 12px;
		min-width: 0;

		.g-block-video-row--h5 & {
			gap: 0.24rem;
		}
	}

	.g-block-video-row__thumb {
		position: relative;
		flex-shrink: 0;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		&.is-playable {
			cursor: pointer;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 24px;
			color: #bfbfbf;
		}

		.g-block-video-row--h5 & i {
			font-size: 0.48rem;
		}
	}

	.g-block-video-row__play {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		margin: -16px 0 0 -16px;
		border-radius: 50%;
		background: rgba(0, 0, 0, 0.45);
		pointer-events: none;

		.g-block-video-row--h5 & {
			width: 0.64rem;
			height: 0.64rem;
			margin: -0.32rem 0 0 -0.32rem;
		}
	}

	.g-block-video-row__triangle {
		display: block;
		width: 0;
		height: 0;
		margin-left: 2px;
		border-top: 6px solid transparent;
		border-bottom: 6px solid transparent;
		border-left: 9px solid #fff;

		.g-block-video-row--h5 & {
			margin-left: 0.04rem;
			border-top-width: 0.12rem;
			border-bottom-width: 0.12rem;
			border-left-width: 0.18rem;
		}
	}

	.g-block-video-row__info {
		flex: 1;
		min-width: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 2px 0;
	}

	.g-block-video-row__title {
		font-size: 15px;
		font-weight: 600;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-video-row--h5 & {
			font-size: 0.3rem;
		}
	}

	.g-block-video-row__desc {
		margin-top: 4px;
		font-size: 12px;
		line-height: 1.5;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;

		.g-block-video-row--h5 & {
			margin-top: 0.08rem;
			font-size: 0.24rem;
		}
	}

	.g-block-video-row__meta {
		display: flex;
		align-items: center;
		gap: 4px;
		margin-top: 6px;
		font-size: 11px;
		line-height: 1;

		.g-block-video-row--h5 & {
			gap: 0.08rem;
			margin-top: 0.12rem;
			font-size: 0.22rem;
		}
	}

	.g-block-video-row__clock {
		width: 12px;
		height: 12px;
		flex-shrink: 0;

		.g-block-video-row--h5 & {
			width: 0.24rem;
			height: 0.24rem;
		}
	}

	.g-block-video-row__player {
		position: fixed;
		left: 0;
		top: 0;
		z-index: 9999;
		width: 100%;
		height: 100%;
		object-fit: contain;
		background: #000;
	}

	.g-block-video-row__close {
		position: fixed;
		top: 20px;
		right: 20px;
		width: 40px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 50%;
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		z-index: 10000;
	}
</style>
